import React, { useContext } from 'react'
import { isEmpty } from 'lodash'
import { minAvisosEnFacetas } from '@navent-jobs/interlinking'
import { ThemeContext } from 'styled-components'
import { dateUtils } from '@navent-jobs/config'
import { useTranslation } from 'react-i18next'

// ui-kit
import { Col, Container, Row } from '@navent-jobs/ui-kit/components/grid'
import Text from '@navent-jobs/ui-kit/components/text'
import { Chip } from '@navent-jobs/ui-kit/components/chip'

// mixins
import { InformationItem, LinkItem, DateContainer, ChipContainer, AvisoContainer } from '../common/mixins'

// utils
import { calcularCantidadDeDias } from '../../../../../../../utils/calculate-days-publication'
import { IS_ZONA_JOBS, SITE_ID } from '../../../../../../../constants'
import features from '../../../../../../../constants/features-per-country'

const searchAvisosV2Enabled = features[SITE_ID || 'BMAR'].searchAvisosV2.enabled

const traductorUbicacion = detalle => {
  const detalleSeparado = detalle.split(',')
  if (!IS_ZONA_JOBS || detalleSeparado.length !== 3) return detalle
  return `${detalleSeparado[0]}, ${detalleSeparado[1]}`
}

const DetalleAviso = ({ aviso, urlMaker, postulacionRapida }) => {
  const { colors } = useContext<{ colors }>(ThemeContext)
  const noFollowLocalizacion = aviso?.localizacion.cantidadAvisos < minAvisosEnFacetas
  const isAvisoSinFronteras = aviso?.modalidadTrabajo.id === 4
  const fechaPublicacion = aviso?.fechaPublicacion
  const fechaHoraPublicacion = aviso?.fechaHoraPublicacion
  const fechaModificado = aviso?.fechaModificado
  const avisoNuevo = dateUtils.getTiempoPublicado(fechaPublicacion) < 1
  const { t } = useTranslation()

  return (
    <Container noGutter>
      <Row noGutter>
        <Col noGutter>
          <ChipContainer>
            {postulacionRapida && (
              <Chip
                text={t('fichaAviso.postulacionRapida')}
                iconName="icon-light-flash-on"
                chipOptions={{ color: 'extra', skin: 'fill', variant: 'darken', size: 'small' }}
              />
            )}
            {aviso?.cantidadVacantes && aviso?.cantidadVacantes > 1 && (
              <Chip
                text="Múltiples vacantes"
                iconName="icon-light-people"
                chipOptions={{ color: 'extra', skin: 'outline', variant: 'darken', size: 'small' }}
              />
            )}
            {!isEmpty(fechaPublicacion) && !isEmpty(fechaHoraPublicacion) && aviso.tipoAviso !== 'infinit' && (
              <DateContainer>
                {avisoNuevo && (
                  <Chip
                    chipOptions={{ color: 'black', skin: 'outline', variant: 'lighten', size: 'small' }}
                    text="Nuevo"
                  />
                )}
                <Text size="xs" fontWeight="semibold" variant="gray60" as="h2">
                  {calcularCantidadDeDias(fechaModificado, fechaHoraPublicacion, fechaPublicacion)}
                </Text>
              </DateContainer>
            )}
          </ChipContainer>
        </Col>
      </Row>
      <Row noGutter>
        <Col noGutter>
          <AvisoContainer>
            {!isEmpty(aviso.localizacion.detalle) && !isAvisoSinFronteras && (
              <InformationItem>
                <LinkItem
                  href={`${
                    urlMaker &&
                    urlMaker({
                      provincia: searchAvisosV2Enabled
                        ? aviso.localizacion.provinciaIdSemantico
                        : aviso.localizacion.provinciaStringId,
                      localidad: searchAvisosV2Enabled
                        ? aviso.localizacion.localidadIdSemantico
                        : aviso.localizacion.localidadStringId,
                    })
                  }`}
                  disabled={!urlMaker}
                  icon={{
                    name: 'icon-light-location-pin',
                    color: colors.secondary.normal,
                    position: 'left',
                  }}
                  linkoptions={{
                    native: !IS_ZONA_JOBS,
                    size: 'medium',
                    type: 'link',
                    variant: 'secondary',
                    block: true,
                  }}
                  noFollow={noFollowLocalizacion}
                  {...(noFollowLocalizacion && {
                    link: `${
                      urlMaker &&
                      urlMaker({
                        provincia: searchAvisosV2Enabled
                          ? aviso.localizacion.provinciaIdSemantico
                          : aviso.localizacion.provinciaStringId,
                        localidad: searchAvisosV2Enabled
                          ? aviso.localizacion.localidadIdSemantico
                          : aviso.localizacion.localidadStringId,
                      })
                    }`,
                  })}
                >
                  <Text as="h2" size="sm" variant="gray60">
                    {traductorUbicacion(aviso.localizacion.detalle)}
                  </Text>
                </LinkItem>
              </InformationItem>
            )}
          </AvisoContainer>
        </Col>
      </Row>
    </Container>
  )
}

export default DetalleAviso
